export default __webpack_public_path__ + "static/media/marker-icon.5692c639.png";